import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfViewer = (props) => {
  const [numPages, setNumPages] = useState(null);

  return(
    <Document
      file={props.url}
      onLoadSuccess={({ numPages }) => {
        setNumPages(numPages);
      }}
    >
      {Array.from(new Array(numPages), (el, index) => (
        <Page
          key={index}
          pageNumber={index + 1}
          renderAnnotationLayer={false}
          renderTextLayer={false}
        />
      ))}
    </Document>
  );
}

export default PdfViewer;